import { IntegrationToken } from '@/features/integrations/api/get-integration-tokens';
import { supabase } from '@/lib/supabase';

export interface GenerateIntegrationTokenResponse {
  token: string;
  integrationToken: IntegrationToken;
}

export async function generateIntegrationToken(
  organizationId: number,
  projectId: number,
  tokenName: string,
): Promise<GenerateIntegrationTokenResponse> {
  const { data, error } = await supabase.rpc('generate_org_integration_token', {
    p_org_id: organizationId,
    p_project_id: projectId,
    p_token_name: tokenName,
  });

  if (error || !data) {
    throw new Error(error?.message || 'Failed to generate integration token');
  }

  try {
    return data as unknown as GenerateIntegrationTokenResponse;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
    throw new Error('Failed to generate integration token: Unknown error');
  }
}
